export default __webpack_public_path__ + "static/casestudy_3-df88024d0ed65a458637c5b3f9b6b0e6.png";